import { useState } from "react";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { AuthShell } from "@/components/AuthShell";
import { FormField } from "@/components/FormField";
import { homeFor, useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";
import { ui } from "@/lib/ui";

export default function StaffLogin() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  if (user) return <Navigate to={homeFor(user)} replace />;

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      navigate(homeFor(await login(email, password)), { replace: true });
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthShell
      eyebrow="staff terminal"
      title="Dispatch login"
      subtitle="For admins, dispatchers and drivers. Accounts are created by your admin."
      footer={<Link to="/login" className="font-mono text-xs uppercase tracking-wider text-slate-500 hover:text-cyan-300" data-testid="customer-login-link">← Customer sign in</Link>}
    >
      <form onSubmit={submit} className="space-y-5" data-testid="staff-login-form">
        <FormField id="email" label="Email">
          <Input id="email" type="email" required autoComplete="email" value={email} onChange={(e) => setEmail(e.target.value)} className={`h-11 ${ui.input}`} data-testid="staff-email-input" />
        </FormField>
        <FormField id="password" label="Password">
          <Input id="password" type="password" required autoComplete="current-password" value={password} onChange={(e) => setPassword(e.target.value)} className={`h-11 ${ui.input}`} data-testid="staff-password-input" />
        </FormField>
        {error && <p className="font-mono text-sm text-[#FF2A2A]" data-testid="staff-login-error">{error}</p>}
        <Button type="submit" disabled={busy} className={`${ui.btnPrimary} w-full h-11`} data-testid="staff-login-submit-button">
          {busy && <Loader2 className="w-4 h-4 mr-2 animate-spin" />}Authenticate
        </Button>
      </form>
    </AuthShell>
  );
}
